import React, { Component } from "react"
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { BookingStatusBadge } from './DesignFunctions'

import { womanAvatar, manAvatar } from '../static/svg/avatars'
import timerIcon from '../static/img/timer-icon.png'
import StarRaters from './StarRaters'

class BookingLine extends Component {
	render() {
		let { t } = this.context
		let { booking, showReview, prefillReviewModal } = this.props
		let date = booking.start.format('dddd DD.MM.YYYY')
		let fmtTime = `${date} ${t('from')} ${booking.start.format('HH:mm')} ${t('to')} ${booking.end.format('HH:mm')}`
		return(
			<div className="BookingLine">
				<Link className="top" to={booking.detailsLink}>
					<div className="worker-pic">{booking.workerTitle === 'mr' ? manAvatar : womanAvatar}</div>
					<div className="booking-infos">
						<div className="worker-name">{booking.workerName}</div>
						<div className="affiliate">{booking.affiliateName}</div>
						<div className="time">
							<img alt="timer" src={timerIcon}/>
							{fmtTime}
						</div>
					</div>
					<BookingStatusBadge status={booking.status} t={t}/>
				</Link>
				{showReview &&
					<div className="bottom">
						<div className="review-prompt">{t('what_did_you_think_of_this_service')}</div>
						<StarRaters value={0} onChange={prefillReviewModal}/>
					</div>
				}
			</div>
		)
	}
}

BookingLine.contextTypes = { t: PropTypes.func }
BookingLine.defaultProps = {
	showReview: false
}

export default BookingLine



// WEBPACK FOOTER //
// ./src/components/BookingLine.js